import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectIsMapReady } from '../../store/map/map.selectors'
import { useMapContext } from './MapContext'
import useErrorBoundaryCallback from '../utils/useErrorBoundaryCallback'
import { getBBoxAroundPointer } from '../utils/map'
import { LAYER_ID_CMM, LAYER_ID_POLYLINE } from '../../store/map/map.constants'
import { isGE } from '../Device'
import { selectIsFrenchSite } from '../../store/locale/locale.selectors'
import { selectQuizGuessInProgress } from '../../store/quiz/quiz.selectors'

const useMapPointerHandler = () => {
  const { map } = useMapContext()
  const mapReady = useSelector(selectIsMapReady)
  const isFrenchSite = useSelector(selectIsFrenchSite)
  const quizGuessInProgress = useSelector(selectQuizGuessInProgress)

  const getPolylinesOrCmmLayersAroundPointer = useErrorBoundaryCallback(
    event =>
      map.queryRenderedFeatures(getBBoxAroundPointer(event)).find(feature => {
        const layerId = feature.layer?.id ?? ''
        const polyline = LAYER_ID_POLYLINE.test(layerId)
        const cmm = isFrenchSite ? LAYER_ID_CMM.test(layerId) : false
        return polyline || cmm
      }),
    [map, isFrenchSite]
  )

  const handleMouseOver = useErrorBoundaryCallback(
    e => {
      const shouldDisplayPointer = getPolylinesOrCmmLayersAroundPointer(e)
      map.getCanvas().style.cursor = quizGuessInProgress ? 'crosshair' : shouldDisplayPointer ? 'pointer' : ''
    },
    [map, getPolylinesOrCmmLayersAroundPointer, quizGuessInProgress]
  )

  useEffect(() => {
    if (isGE()) {
      if (map && mapReady) map.on('mousemove', handleMouseOver)
      return () => {
        if (map) map.off('mousemove', handleMouseOver)
      }
    }
  }, [map, mapReady, handleMouseOver])
}

export default useMapPointerHandler
